import type { APIGameRecommendation, GameRecommendationType, ShortGameType, ShortGameZipType } from '@/types'
import { unzipShortGame, zipAPIGame } from '@/utils/helpers'

export const GAME_PAGE_RECOMMENDATION_TYPES: GameRecommendationType[] = [
    'related',
    'random',
    'series',
    'developer',
    'linked_categories',
]

export type GamePageRecommendationsZip = {
    recommended: ShortGameZipType[]
    top_playgama: ShortGameZipType[]
    related: ShortGameZipType[]
    random: ShortGameZipType[]
    series: ShortGameZipType[]
    developer: ShortGameZipType[]
}

export type GamePageRecommendations = {
    recommended: ShortGameType[]
    top_playgama: ShortGameType[]
    related: ShortGameType[]
    random: ShortGameType[]
    series: ShortGameType[]
    developer: ShortGameType[]
}

export function emptyGamePageRecommendations(): GamePageRecommendationsZip {
    return {
        recommended: [],
        top_playgama: [],
        related: [],
        random: [],
        series: [],
        developer: [],
    }
}

export function zipGamePageRecommendations(
    recommendations: Partial<APIGameRecommendation<GameRecommendationType[]>>,
): GamePageRecommendationsZip {
    return {
        recommended: recommendations.recommended?.slice(0, 12).map(zipAPIGame) || [],
        top_playgama: recommendations.top_playgama?.slice(0, 12).map(zipAPIGame) || [],
        related: recommendations.related?.slice(0, 12).map(zipAPIGame) || [],
        random: recommendations.random?.map(zipAPIGame) || [],
        series: recommendations.series?.slice(0, 12).map(zipAPIGame) || [],
        developer: recommendations.developer?.slice(0, 12).map(zipAPIGame) || [],
    }
}

export function unzipGamePageRecommendations(recommendations: GamePageRecommendationsZip): GamePageRecommendations {
    return {
        recommended: recommendations.recommended.map(unzipShortGame),
        top_playgama: recommendations.top_playgama.map(unzipShortGame),
        related: recommendations.related.map(unzipShortGame),
        random: recommendations.random.map(unzipShortGame),
        series: recommendations.series.map(unzipShortGame),
        developer: recommendations.developer.map(unzipShortGame),
    }
}
